import cls from "@fvilers/cls";
import { ComponentPropsWithRef } from "react";
import styles from "./Dialog.module.css";

export type DialogBodyProps = ComponentPropsWithRef<"section">;

export function DialogBody({ className, ...props }: DialogBodyProps) {
  return <section {...props} className={cls(styles.DialogBody, className)} />;
}
